import React from 'react';

import {message} from 'antd';
import {observable} from "mobx";
import http from 'libs/http';

import {history} from "../../../libs";


// the hook
import { useTranslation } from 'react-i18next';

class Store {
  @observable userInfo = {};
  @observable quoteRecords = [];
  @observable addresses = [];
  @observable invoices = [];
  @observable isFetching = false;


  //获取用户信息
  fetchUserInfo = () => {
    this.isFetching = true;
    http.get('/javaApi/front/customer/getUserInfo')
      .then(res => {
        console.log(res,'res');
        this.userInfo=res.data.result
        localStorage.setItem('nickname', res.data.result['name']);
        localStorage.setItem('userInfo', JSON.stringify(res.data.result));
      })
      .finally(() => this.isFetching = false)


  };

  //更新用户信息
  updateUserInfo = (formData) => {
    this.isFetching = true;
    http.post('/frontApi/customer/updateUserFile/', formData)
      .then(data => {
        message.success('修改成功！')
        localStorage.setItem('username', formData['phone']);

        http.get('/frontApi/customer/get_user_info/')
          .then(data => {

            localStorage.setItem('nickname', data['name']);
            localStorage.setItem('userInfo', JSON.stringify(data));

            // history.replace('')
            history.replace('/user/info')
          })
      })
      .finally(() => {
        this.isFetching = false;
      })
  }

  //修改密码
  updatePassword = (formData) => {
    if(formData['old']!==localStorage.getItem('password')){
      message.error('原登录密码错误！')
      return
    }
    return http.post('/frontApi/customer/updateUserPass/', formData)
      .then(data => {
        message.success('修改成功！请重新登录！')
        localStorage.setItem('token', '');
        localStorage.setItem('nickname', '');
        localStorage.setItem('redirect_uri', '/');
        history.push('/login')
      })
  }


}

export default new Store()

/// ----------------------------

// access_token: "85652116c75b4bfaa0f305285389c715"
// appms_time: "2020-10-19 22:51:21"
// apporder_time: "2020-09-27 16:46:48"
// approve_role: "2"
// cart_time: "2020-10-29 17:22:31"
// create_time: "2019-02-27 17:33:39"
// default_invoice: 260
// department_id: 353
// email: "caiaq@innoviews.com"
// gender: ""
// ibc_id: 88
// id: 8
// is_approve: true
// last_login_time: "2020-10-30 09:01:01"
// login_timestamp: 1604020561
// mail_approve: true
// mail_devilery: false
// mail_new_approve: true
// mail_preorder: true
// name: "蔡安骐（测试）"
// openid: "oYH5g1KKHjRkZhc2VjUrVWgdkWag"
// organization_id: 182
// organization_str: null
// phone: "13921509350"
// preorder_time: "2020-10-29 13:58:46"
